import { useEffect } from "react";
import { Capacitor } from "@capacitor/core";

export function usePullToRefresh(onRefresh: () => void) {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let startY = 0;
    let isPulling = false;

    function handleTouchStart(e: TouchEvent) {
      if (window.scrollY === 0) {
        startY = e.touches[0].clientY;
        isPulling = true;
      }
    }

    function handleTouchEnd(e: TouchEvent) {
      if (!isPulling) return;
      const endY = e.changedTouches[0].clientY;
      const diff = endY - startY;
      if (diff > 80) {
        onRefresh();
      }
      isPulling = false;
    }

    document.addEventListener("touchstart", handleTouchStart, { passive: true });
    document.addEventListener("touchend", handleTouchEnd, { passive: true });

    return () => {
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchend", handleTouchEnd);
    };
  }, [onRefresh]);
}
